import { __extends } from "tslib";
import { UpdateSmsTemplateRequest, UpdateSmsTemplateResponse } from "../models/index";
import { deserializeAws_restJson1UpdateSmsTemplateCommand, serializeAws_restJson1UpdateSmsTemplateCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateSmsTemplateCommand = /** @class */ (function (_super) {
    __extends(UpdateSmsTemplateCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateSmsTemplateCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateSmsTemplateCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: UpdateSmsTemplateRequest.filterSensitiveLog,
            outputFilterSensitiveLog: UpdateSmsTemplateResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateSmsTemplateCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1UpdateSmsTemplateCommand(input, context);
    };
    UpdateSmsTemplateCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1UpdateSmsTemplateCommand(output, context);
    };
    return UpdateSmsTemplateCommand;
}($Command));
export { UpdateSmsTemplateCommand };
//# sourceMappingURL=UpdateSmsTemplateCommand.js.map